import * as React from "react";
import Svg, { Circle, Path, Rect } from "react-native-svg";
const SVGComponent = (props) => (
  <Svg
    width={14}
    height={14}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Circle cx={7} cy={7} r={7} fill="white" fillOpacity={1} />
    <Path
      d="M-9.53674e-07 6.44116C-9.53674e-07 6.81318 -9.53674e-07 7.18886 -9.53674e-07 7.56088C0.0328341 7.86361 0.0510759 8.16269 0.116746 8.46177C0.361184 9.5742 0.842763 10.5736 1.56513 11.4526C2.09049 12.0908 2.70706 12.6234 3.42213 13.0428C4.29773 13.5571 5.23899 13.8853 6.25323 13.9692C7.43529 14.064 8.59545 13.951 9.70089 13.4732C10.4743 13.1376 11.1748 12.6927 11.7914 12.1091C12.3897 11.5437 12.8822 10.9018 13.2544 10.1724C13.6447 9.39913 13.9074 8.58213 13.9694 7.72136C14.0278 6.90437 14.0169 6.08737 13.8089 5.28496C13.5243 4.18712 13.0172 3.20599 12.2657 2.35616C11.7111 1.72518 11.0654 1.20361 10.3248 0.806056C9.59144 0.412147 8.81435 0.153187 7.99348 0.0364731C7.84025 0.0145893 7.68702 0.0291785 7.53379 0C7.1872 0 6.84061 0 6.49767 0C6.39186 0.0328258 6.28241 0.0145893 6.17661 0.0255312C5.47249 0.0729463 4.81214 0.284491 4.17004 0.554392C3.52428 0.824293 2.94055 1.20361 2.41154 1.65953C1.76944 2.21757 1.23313 2.86679 0.824521 3.61814C0.423205 4.36219 0.153229 5.14636 0.0364828 5.98524C0.0182409 6.13478 0.0291862 6.28797 -9.53674e-07 6.44116Z"
      fill={props.CircleColor || "white"}
    />
    <Rect
      x={6}
      y={6}
      width={2}
      height={5}
      rx={1}
      fill={props.IColor || "black"}
      fillOpacity={1}
    />
    <Path
      d="M6.98986 5C7.28802 5 7.55196 4.88329 7.76213 4.63874C8.09938 4.23858 8.07495 3.66057 7.70836 3.29375C7.33201 2.92138 6.7357 2.89915 6.33979 3.24929C5.895 3.64389 5.88523 4.32195 6.32024 4.73323C6.50109 4.90552 6.73081 5 6.98986 5Z"
      fill={props.DotColor || "black"}
      fillOpacity={1}
    />
  </Svg>
);
export default SVGComponent;
